import { gql } from 'graphql-request';

export const DAILY_SITE_REPORT_SUMMARY_FIELDS = gql`
  fragment DailySiteReportSummaryFields on DailySiteReportSummaryDto {
    reportId
    organizationId
    userId
    localDate
    timezone
    windowStart
    windowEnd
    trigger
    emailStatus
    isEmpty
    sentAt
    counts {
      statusChanges
      tasksCompleted
      incidents
      punchUsers
      notes
      documents
      stockTransactions
      tasksTomorrow
      pendingIncidents
    }
    createdAt
  }
`;

// DailySiteReportDto and DailySiteReportSummaryDto are unrelated GraphQL types (the TS class
// inheritance is not exposed as an interface), so the summary fragment cannot be spread here.
export const DAILY_SITE_REPORT_FIELDS = gql`
  fragment DailySiteReportFields on DailySiteReportDto {
    reportId
    organizationId
    userId
    localDate
    timezone
    windowStart
    windowEnd
    trigger
    emailStatus
    isEmpty
    sentAt
    counts {
      statusChanges
      tasksCompleted
      incidents
      punchUsers
      notes
      documents
      stockTransactions
      tasksTomorrow
      pendingIncidents
    }
    createdAt
    errorMessage
    schemaVersion
    sections
  }
`;

export const dailySiteReportAvailable = gql`
  query dailySiteReportAvailable {
    dailySiteReportAvailable
  }
`;

export const dailySiteReportSettings = gql`
  query dailySiteReportSettings {
    dailySiteReportSettings {
      available
      organizationTimezone
      organizationSendHour
      canEditOrganizationSettings
      emailEnabled
      manualSendsRemainingToday
      nextScheduledSendAt
      eligible
      ineligibleReason
    }
  }
`;

export const myDailySiteReports = gql`
  query myDailySiteReports($limit: Int, $offset: Int) {
    myDailySiteReports(limit: $limit, offset: $offset) {
      ...DailySiteReportSummaryFields
    }
  }
  ${DAILY_SITE_REPORT_SUMMARY_FIELDS}
`;

export const dailySiteReport = gql`
  query dailySiteReport($reportId: String!) {
    dailySiteReport(reportId: $reportId) {
      ...DailySiteReportFields
    }
  }
  ${DAILY_SITE_REPORT_FIELDS}
`;

export const updateDailySiteReportOrganizationSettings = gql`
  mutation updateDailySiteReportOrganizationSettings($input: DailySiteReportOrganizationSettingsInput!) {
    updateDailySiteReportOrganizationSettings(input: $input) {
      available
      organizationTimezone
      organizationSendHour
      canEditOrganizationSettings
      emailEnabled
      manualSendsRemainingToday
      nextScheduledSendAt
      eligible
      ineligibleReason
    }
  }
`;

export const sendMyDailySiteReportNow = gql`
  mutation sendMyDailySiteReportNow {
    sendMyDailySiteReportNow {
      ...DailySiteReportFields
    }
  }
  ${DAILY_SITE_REPORT_FIELDS}
`;

const DailySiteReportGraphQL = {
  queries: {
    dailySiteReportAvailable,
    dailySiteReportSettings,
    myDailySiteReports,
    dailySiteReport,
  },
  mutations: {
    updateDailySiteReportOrganizationSettings,
    sendMyDailySiteReportNow,
  },
};

export default DailySiteReportGraphQL;
